<template>
    <div class="custom-tree-container">

        <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
          
          <el-upload class="fl" style="margin-right: 10px"  >
            <el-button size="small" type="primary" @click="addPirce">添加活动</el-button>
          </el-upload>
        
          
        </el-row>
        <el-button size="small" type="primary" @click="showTempImg">模板样式说明</el-button>
        
      <el-table :data="reviewList"  v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="title" label="活动名称" width="140"></el-table-column>
      <el-table-column prop="msg" label="活动说明" width="140"></el-table-column>
      <el-table-column prop="start_time" label="开始时间" width="140">
        <template slot-scope="scope">
          {{scope.row.start_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      <el-table-column prop="end_time" label="结束时间" width="140">
        <template slot-scope="scope">
          {{scope.row.end_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      
      <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button  type="success" class=""  @click="showreviewDetail(scope.row.id)">
              查看活动商品
            </el-button>
           <span></span>
            <el-upload   :on-change="upPrice" :auto-upload="false" :show-file-list="false" >
              <el-button  @click="selectTid(scope.row.id)" type="danger">上传活动商品及价格</el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
      <el-dialog title="模板格式 文件名称格式x年x月x日商品审核.xlsx" :visible.sync="dialogS">
        <div class="content-center">
          <img :src="tempImg">
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hideTmp">下载模板</el-button>
        </span>
      </el-dialog>
    </div>
    
     
</template>
<script>
  import { mapGetters } from 'vuex'
  import {getPriceReviewList,getPriceReviewTitleList,reviewPriceDo,reviewUpload} from '@/api/goods';

  import {getAreaManageList} from "@/api/areamanage";
  import {getShopTypes} from '@/api/marketing';

  export default {
    
    data() {
      return {
        tempImg:'https://b-img-cdn.yaoking.cn/1/2023/06/19/af8a2ee434f9e61f2cca20e46025d4d6mDsjRtAaesUBLZXEAvClrNP1SAGgAtlY',
        dialogS:false,
        isDisable: false,
        loading: false,
        spaceInput: false,
        categoryList: [],
        total_count: 0,
        params:{
          page: 1,
          pageSize: 20,
        },
        imgDialog: false,
        isGetImage: true,
        current: '',
        category_id: '',
        show_batchStore: false,
        submitLoading: false,
        batchsubmitLoading:false,
        districtId:0,
        updateBatchList:[],
        shop_type_list: [],
        reviewList:[],
        itemstore: 0,
        select_title_id:'',
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      showTempImg()
      {
        this.dialogS = true
      },
      hideTmp()
      {
        this.dialogS = false
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getPriceReviewList()
      },
      getPriceReviewList(){
        // getPriceReviewList(this.params).then(response => {
        //   this.reviewList = response.data.data.list
        //   this.total_count = response.data.data.total_count
        //   this.loading = false
        // })
        getPriceReviewTitleList(this.params).then(response => {
          this.reviewList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
        
      },
      
      reviewPriceDo(id,status)
      {

        let status_var = '是否通过, 是否继续?'
        if(status == '2'){
          status_var = '是否拒绝, 是否继续?'
        }
        this.$confirm(status_var, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          reviewPriceDo({id:id,status:status}).then(response=>{
          let status = response.data.data.status
          var messInfo = status ? '操作成功' : '操作失败';
          var typeMes  = status ? 'success' : 'error';
          this.$message({
            type: typeMes,
            message: messInfo
          });
          })
          this.getPriceReviewList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
        
      },
      showreviewDetail(rowid){
        // 跳转具体互动列
        console.log(rowid+'=======');
        this.$router.push({path:'/entity/goods/goodspricereviewlist?id='+rowid})
        // this.$router.push({path:'/store/storemanager/distributor_selfActivity/distributor_selfActivity_editor/'+row.id})
      },
      addPirce(){
        // 添加活动

        this.$router.push({path:'/entity/goods/goodspricereviewtitle'})
      },
      selectTid(tid){
        this.selectTid = tid
      },
      upPrice(file,fileList){
        

        // console.log(this.selectTid,'vvvvvvv')
        let params = {isUploadFile: true,file:file.raw,title_id:this.selectTid}
        reviewUpload(params).then(response=>{
          let status = response.data.data.status
          var messInfo = response.data.data.data;
          var typeMes  = status ? 'success' : 'error';
          this.$message({
            type: typeMes,
            message: messInfo
          });
        })
      },
      
      toDistributor(category_id) {
        this.category_id=category_id
        this.show_rebate_sideBar = false
        // this.show_sideBar = true
        this.show_batchStore = true
        this.getBatchData()
      },
      
      getBatchData(){
        this.skuLoading = true
        this.updateBatchList[''] = '';
        getShopTypes().then(res => {
          this.shop_type_list  = res.data.data.list
        })
        this.skuLoading = false
      },
      getOfficeArea(){
        getAreaManageList({'format_flag':true}).then(response => {
          this.params.page = 1;
          this.new_office_area =response.data.data;
        })
      } ,
      switchAuth(node, data) {
          let params = {
              'recommend': data.recommend ,
          }
          updateCategory(data.category_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getCategory()
              }
          })
      },
      editRecommendSort(node, data) {
          let params = {
              'recommend_sort': data.recommend_sort ,
          }
          updateCategory(data.category_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getCategory()
              }
          })
      },
      updatePriceView() {

        
      },
      deleteCategory(node, data) {
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof (data.category_id) != 'undefined') {
            deleteCategory(data.category_id).then(response => {
              this.$message({
                type: 'success',
                message: '删除分类成功'
              })
              this.getCategory()
            })
          } else {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.category_name === data.category_name);
            children.splice(index, 1);
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      append(data, level = 0) {
        const newChild = {category_name: '', sort: 0, level: ++level, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      appendTop(data) {
        const newChild = {category_name: '', sort: 0, level: 0, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      catNameCheck(catName) {
        let catNameLength = 0
        if (catName) {
          for (var i = 0; i < catName.length; i++) {
            if (catName.charCodeAt(i) > 255) {
              catNameLength += 2;
            } else {
              catNameLength++;
            }
          }
          if (catNameLength > 50) {
            this.$message({
              type: 'error',
              message: '分类名称长度最多25个汉字或50个字符'
            })
            return false
          }
          return true
        } else {
          this.$message({
            type: 'error',
            message: '分类不能为空'
          })
          return false
        }
      },
      handleImgChange(data) {
        this.imgDialog = true
        this.isGetImage = true
        this.current = data
      },
      pickImg(data) {
        if (!this.current.parent_id || this.current.parent_id == 0) {
          const index = this.categoryList.findIndex(d => d.id === this.current.id);
          this.categoryList[index].image_url = data.url
        } else if (this.current.parent_id && this.current.level == 1) {
          const findex = this.categoryList.findIndex(d => d.id === this.current.parent_id);
          const cindex = this.categoryList[findex].children.findIndex(d => d.id === this.current.id);
          this.categoryList[findex].children[cindex].image_url = data.url
        } else {
          let findex
          let cindex
          for (var item in this.categoryList) {
            cindex = this.categoryList[item].children.findIndex(d => d.id === this.current.parent_id);
            findex = item
            if (cindex > -1) break
          }
          const tindex = this.categoryList[findex].children[cindex].children.findIndex(d => d.id === this.current.id);
          this.categoryList[findex].children[cindex].children[tindex].image_url = data.url

        }
        this.imgDialog = false
      },
      closeImgDialog() {
        this.imgDialog = false
      },
    },

    mounted() {
      this.getPriceReviewList()
    }
  };
</script>

<style scoped lang="scss">
    .custom-tree-container {
        background-color: #fff;
        min-width: 1100px;
    }

    .tree-background {
        padding-bottom: 45px;
        margin: 0px 20px;
    }

    .custom-tree-node, .custom-tree-node-title {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        /*padding-right: 8px;*/
        li {
            display: inline-block;
            text-align: center;
            width: 25%;
        }

        li:first-child {
            text-align: left;
        }

        li.category-icon {
            display: flex;
            align-items: middle;
            justify-content: center;

            span {
                height: 30px;
            }

            img {
                width: auto;
                height: 30px;
            }
        }
    }

    .custom-tree-node-title {
        font-weight: bold;
        color: #909399;
        margin: 0px 20px;

        li {
            padding: 12px 0;
        }
    }

    .add-category {
        margin-left: 25px;
        margin-top: 30px;

        span {
            cursor: pointer;
        }
    }

    .remove-category {
        margin-left: 10px;
    }

    .add-child-category {
        margin-left: 10px;
    }
</style>
<style lang="scss">
    .custom-tree-container {
        .el-tree-node__content {
            height: 45px;
            padding: 0px;
            line-height: 45px;
        }

        .el-tree > .el-tree-node {
            position: relative;

            &::after {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                bottom: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }

        .el-tree > .el-tree-node:first-child {
            &::before {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                top: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }
    }

    .custom-tree-node {
        input {
            border: 1px solid #ddd;
            line-height: 25px;
            padding-left: 5px;
            width: 150px;
        }
    }

</style>



// WEBPACK FOOTER //
// priceview.vue?5ef8d8b7